/** Empresas fixas — Santander: empresa 1 (config + títulos). */
export const FIN_SANTANDER_ID_EMPRESA_CONFIG = 1;
export const FIN_CONTA_RECEBER_ID_EMPRESA_LISTAGEM = 1;
